module.exports = __webpack_public_path__ + "media/images/client/favicons/icon-24x24-1c79a7e180b9e7fe11792466a0359824.png";